import styled from 'styled-components';

export const ContainerStyled = styled.div`
    font-size: ${props => `${props.fontSize}px !important`};
    &.bounce {
        height: 40px;
        overflow: hidden;
        position: fixed;        
        z-index: 1300;
        width: -webkit-fill-available;
        cursor: text;
        white-space: nowrap;
        width: 101%;
    }
    
    &.bounce div {        
        width: 100%;
        height: 100%;
        margin: 0;
        line-height: normal;
        text-align: left;
        animation: animate 45s linear infinite;   
        display: table;  
        padding: 7px 0;
    }
    &.bounce button {
      background: none;
      height: 26px;
      border-radius: 20px;
      margin: 0 10px;
      border-width: 1px;
    }

    &.bounce .fullHeight {
     height: 100%;
    }

    &.bounce:hover div {
      animation-play-state: paused;
    }

    &.bounce:hover button {
      background: #FFFFFF
    }
    
    @keyframes animate {
        0% {
          transform: translateX(100%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
`